import { render, staticRenderFns } from "./DelayOrder.vue?vue&type=template&id=ec1bfa6c&scoped=true"
import script from "./DelayOrder.vue?vue&type=script&lang=js"
export * from "./DelayOrder.vue?vue&type=script&lang=js"
import style0 from "./DelayOrder.vue?vue&type=style&index=0&id=ec1bfa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1bfa6c",
  null
  
)

export default component.exports